module.exports = __webpack_public_path__ + "static/SrisakdiRegular-ba1d593f3d55e36f1c236fbf79abf259.ttf";